import request from "@/utils/request";

// 查询配置列表
export const  humItemList =(query) =>{
    return request({
        url: "/businessservice/humanityItem/classify",
        method:"get",
        params: query
    })
}

// 查询主题信息及其子分类列表
export const  infoHumItem =(query) =>{
    return request({
        url: "/businessservice/humanityItem/info",
        method:"get",
        params: query
    })
}

// 查询配置列表
export const queryClassifyList = (data) => {
    return request({
        url: "/businessservice/humanityItem/classifyList",
        method: "post",
        data: data
    })
}

// 分页查询配置列表
export const pageHumanityItem = (data) => {
    return request({
        url: "/businessservice/humanityItem/page",
        method: "post",
        data: data
    })
}